<template>
  <c-container>
    <c-checkout-progress reservation />
    <c-type-switcher />

    <c-visitor-info reservation>
      <template #title>
        {{ $t('title') }}
      </template>

      <template #introduction>
        <div v-html="getLabel('introduction.reservation')" />
      </template>
    </c-visitor-info>

    <c-ticket-selection
      v-if="!IS_IE && reservationEnabled"
      reservation
    />

    <div
      v-if="!reservationEnabled"
      v-html="getLabel('reservation.disabled')"
    />
  </c-container>
</template>

<script>
import CCheckoutProgress from '../components/checkoutProgress.vue'
import CContainer from '../components/container.vue'
import CTicketSelection from '../components/ticketSelection.vue'
import CTypeSwitcher from '../components/typeSwitcher.vue'
import CVisitorInfo from '../components/visitorInfo.vue'

import dateHelper from '../functions/dateHelper.js'
import labelMixin from '../mixins/label.js'

import { IS_IE, GAP_GIFT_CARD } from '../settings.js'

export default {
  name: 'VReservation',

  components: {
    CCheckoutProgress,
    CContainer,
    CTicketSelection,
    CTypeSwitcher,
    CVisitorInfo
  },

  mixins: [labelMixin],

  data () {
    return {
      reservationCutOff: new Date(2099, 1, 1, 0, 0, 0) // Set to null to always enabled reservations
    }
  },

  computed: {
    IS_IE: () => IS_IE,

    reservationEnabled () {
      if (this.reservationCutOff === null) {
        return true
      }

      const date = new Date(this.$store.state.arrivalTable.active.date)
      date.setHours(0, 0, 0, 0)
      return (this.reservationCutOff.getTime() < date.getTime())
    }
  },

  created () {
    if (this.$store.state.cart.tickets.gap === GAP_GIFT_CARD || this.$store.state.cart.events.gap === GAP_GIFT_CARD) {
      this.$store.dispatch('clearCart', { dontResetSelection: true })
    }

    this.$store.state.isReservation = true
    this.$store.state.isGiftcardOrder = false
    this.$tracking.track(this.$route.path, 'r')
    this.$tracking.eetInit('reservation')

    if (!this.$store.state.ticketSelection.selectedDate) {
      const currentDate = dateHelper.formatDate(dateHelper.getDate())
      this.$store.dispatch('calculateArrivalDates', { currentDate })
    }
  }
}
</script>

<i18n locale="en">
{
  "title": "Ticket Reservation"
}
</i18n>

<i18n locale="de">
{
  "title": "Ticketreservierung"
}
</i18n>
